/* NIKA: персонален bento блок на началната — виж sections/nika-bento-personal.liquid.
   Показва се само при история. Данни: localStorage nika-viewed (продукти с
   main/sub/l1) и nika-viewed-cols (категории); карта на менюто, кратки имена и
   тренд редът са вградени в секцията; продуктите идват от
   /collections/<handle>?view=nika-rank-30d (top_sellers_30d, fallback best-selling). */
(function () {
  var root = document.querySelector('[data-nika-bento-personal]');
  if (!root) return;
  var readJSON = function (sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } };
  /* 09.09: без история → нищо не се тегли; иначе картата на менюто идва от кеширан
     Liquid endpoint (sessionStorage 24ч), а не от 43 KB inline JSON в началната */
  var hasHistory = false;
  try { hasHistory = (JSON.parse(localStorage.getItem('nika-viewed') || '[]') || []).length > 0 || (JSON.parse(localStorage.getItem('nika-viewed-cols') || '[]') || []).length > 0; } catch (e) {}
  if (!hasHistory) return;
  var loadMap = function () {
    try { var c = JSON.parse(sessionStorage.getItem('nika-bp-map') || 'null'); if (c && Date.now() - c.t < 86400000 && c.v && c.v.length) return Promise.resolve(c.v); } catch (e) {}
    return fetch('/collections/all?view=nika-menu-map', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (v) { try { sessionStorage.setItem('nika-bp-map', JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} return v; })
      .catch(function () { return []; });
  };
  loadMap().then(function (rawMap) {
  var map = (rawMap || []).filter(function (x) { return x && x.h; });
  var trend = readJSON('[data-nika-bp-trend]') || [];
  var shortRaw = (root.querySelector('[data-nika-bp-short]') || {}).textContent || '';
  var shortMap = {};
  shortRaw.split(';;').forEach(function (pair) { var kv = pair.split('|'); if (kv[0] && kv[1]) shortMap[kv[0].trim()] = kv[1].trim(); });
  var byH = {}; map.forEach(function (x) { byH[x.h] = x; });
  var trendRank = {}; trend.forEach(function (h, i) { trendRank[h] = i; });

  var viewed = [], viewedCols = [];
  try { viewed = JSON.parse(localStorage.getItem('nika-viewed') || '[]') || []; } catch (e) {}
  try { viewedCols = JSON.parse(localStorage.getItem('nika-viewed-cols') || '[]') || []; } catch (e) {}
  /* контекст = НАЙ-НОВОТО събитие: продукт или категория (по времеви печат) */
  var last = viewed.find(function (v) { return v && v.main; });
  var lastCol = viewedCols.find(function (c) { return c && c.handle && byH[c.handle]; });
  var tP = last && last.t || 0, tC = lastCol && lastCol.t || 0;
  var ctx = null;
  if (lastCol && (!last || tC > tP)) {
    var c = lastCol; var m = byH[c.handle] || {};
    ctx = { sub: m.lvl === 3 ? c.handle : '', main: c.main || (m.lvl === 2 ? c.handle : m.l2) || '', l1: c.l1 || m.l1 || (m.lvl === 1 ? c.handle : '') };
    if (m.lvl === 1) ctx.main = ctx.main || c.handle;
  } else if (last) {
    ctx = { sub: last.sub || '', main: last.main, l1: last.l1 || (byH[last.main] || {}).l1 || '' };
  }
  if (!ctx || !ctx.main) return; /* без история → блокът остава скрит */
  /* стари записи: main може да е leaf (l3) → нормализираме по картата на менюто */
  var mi = byH[ctx.main];
  if (mi && mi.lvl === 3) { ctx.sub = ctx.main; ctx.main = mi.l2; ctx.l1 = ctx.l1 || mi.l1; }
  if (!ctx.l1 && byH[ctx.main]) ctx.l1 = byH[ctx.main].l1 || '';

  var viewedHandles = {}; viewed.forEach(function (v) { if (v && v.handle) viewedHandles[v.handle] = 1; });
  var tpl = function (n, fallback, vars) {
    var t = root.getAttribute('data-t' + n) || fallback;
    return t.replace(/\{вендор\}/g, vars.vendor || '').replace(/\{група\}/g, vars.group || '').replace(/\{категория\}/g, vars.cat || '').replace(/\s+/g, ' ').replace(/[:\-–]\s*$/, '').trim();
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch]; }); };
  var money = function (n) { var p = Number(n).toFixed(2).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ',' + p[1] + ' €'; };
  var label = function (t) { return shortMap[String(t || '').trim()] || t; };
  /* кратко име на продукт: без скоби и опашки след тире, без ГЛАВНИ БУКВИ, без "цена за" */
  var shortTitle = function (t) {
    var s = String(t || '').replace(/\s*\([^)]*\)/g, '').replace(/\s*[-–—]\s*(цена|за\s+\d).*$/i, '').replace(/\s+/g, ' ').trim();
    var letters = s.replace(/[^A-Za-zА-Яа-я]/g, '');
    var upper = letters.replace(/[^A-ZА-Я]/g, '');
    if (letters.length > 6 && upper.length / letters.length > 0.8) s = s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    return s;
  };
  var leaves = function (pred) { return map.filter(function (x) { return x.leaf && x.img && pred(x); }).sort(function (a, b) { return (trendRank[a.h] === undefined ? 999 : trendRank[a.h]) - (trendRank[b.h] === undefined ? 999 : trendRank[b.h]); }); };

  var cacheKey = function (h) { return 'nika-bp-rank:' + h; };
  var fetchRank = function (h) {
    if (!h) return Promise.resolve([]);
    try { var c = JSON.parse(sessionStorage.getItem(cacheKey(h)) || 'null'); if (c && Date.now() - c.t < 1800000) return Promise.resolve(c.v); } catch (e) {}
    var load = function (view) { return fetch('/collections/' + h + '?view=' + view).then(function (r) { return r.ok ? r.json() : []; }).catch(function () { return []; }); };
    return load('nika-rank-30d').then(function (list) {
      if (list && list.length >= 4) return list;
      return load('nika-rank-full&sort_by=best-selling').then(function (fb) {
        var seen = {}; var out = [];
        (list || []).concat(fb || []).forEach(function (p) { if (p && p.handle && !seen[p.handle]) { seen[p.handle] = 1; out.push(p); } });
        return out;
      });
    }).then(function (list) {
      list = (list || []).filter(function (p) { return p && p.available && p.image; });
      try { sessionStorage.setItem(cacheKey(h), JSON.stringify({ t: Date.now(), v: list })); } catch (e) {}
      return list;
    });
  };

  var prodTile = function (p, hero) {
    return '<a class="nika-bento__tile nika-bento__tile--product' + (hero ? ' nika-bento__tile--hero' : '') + '" href="/products/' + esc(p.handle) + '">' +
      '<span class="nika-bento__img"><img src="' + esc(p.image) + '" alt="" loading="lazy" width="300" height="300"></span>' +
      '<span class="nika-bento__label">' + esc(shortTitle(p.title)) + '</span></a>'; /* без цена — по-ниски карти (04.09) */
  };
  var colTile = function (c) {
    return '<a class="nika-bento__tile" href="/collections/' + esc(c.h) + '"><span class="nika-bento__img"><img src="' + esc(c.img) + '" alt="" loading="lazy" width="300" height="300"></span><span class="nika-bento__label">' + esc(label(c.t)) + '</span></a>';
  };
  var card = function (title, tilesHtml, moreHref) {
    return '<div class="nika-bento__card"><h3 class="nika-bento__title">' + esc(title) + '</h3><div class="nika-bento__tiles">' + tilesHtml + '</div>' + (moreHref ? '<a class="nika-bento__more" href="' + esc(moreHref) + '">Виж всички</a>' : '') + '</div>';
  };
  var shuffle = function (a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; };

  var subInfo = byH[ctx.sub] || null, mainInfo = byH[ctx.main] || null, l1Info = byH[ctx.l1] || null;
  var relatedSrc = ctx.sub || ctx.main;                                   /* карта 1 */
  var siblings = leaves(function (x) { return x.l2 === ctx.main && x.h !== ctx.sub; });   /* карта 2: съседна подкатегория */
  var sibling = siblings[0] || null;
  var relCats = leaves(function (x) { return x.l1 === ctx.l1 && x.h !== ctx.sub && (!sibling || x.h !== sibling.h); }).slice(0, 4); /* карта 3 */
  var poolSrc = ctx.l1 || ctx.main;                                       /* карта 4 */

  /* съседна подкатегория с поне 4 налични най-продавани — пробваме до 4 съседа по тренд ред */
  var pickSibling = function (i) {
    if (i >= Math.min(siblings.length, 4)) return Promise.resolve({ sib: null, list: [] });
    return fetchRank(siblings[i].h).then(function (list) {
      var ok = list.filter(function (p) { return !viewedHandles[p.handle]; });
      if (ok.length >= 1) return { sib: siblings[i], list: ok };
      return pickSibling(i + 1);
    });
  };
  /* карта 1: подкатегория → при <4 главна (l2) → при <4 групата (l1) */
  var fetchRelated = function () {
    var chain = [relatedSrc, ctx.main, ctx.l1].filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    var step = function (i) {
      if (i >= chain.length) return Promise.resolve({ list: [], src: relatedSrc });
      return fetchRank(chain[i]).then(function (list) {
        var ok = list.filter(function (p) { return !viewedHandles[p.handle]; });
        if (ok.length >= 4) return { list: list, src: chain[i] };
        if (i === chain.length - 1 && list.length >= 4) return { list: list, src: chain[i] };
        return step(i + 1);
      });
    };
    return step(0);
  };
  Promise.all([fetchRelated(), pickSibling(0), fetchRank(poolSrc), fetchRank(ctx.sub)]).then(function (res) {
    var relatedInfo = byH[res[0].src] || null; res[0] = res[0].list;
    sibling = res[1].sib; res[1] = res[1].list;
    /* подкатегорията има под 4 продукта → тя отива в голямата карта (един винаги има),
       а "Свързани" вече е от главната категория */
    var subList = res[3] || [];
    var subSmall = ctx.sub && res[0].length && relatedInfo && relatedInfo.h !== ctx.sub && subList.length > 0;
    if (subSmall) { sibling = subInfo; res[1] = subList; }
    relCats = leaves(function (x) { return x.l1 === ctx.l1 && x.h !== ctx.sub && (!sibling || x.h !== sibling.h); }).slice(0, 4);
    var used = {};
    var related = res[0].filter(function (p) { return !viewedHandles[p.handle]; });
    if (related.length < 4) related = res[0];
    related = related.slice(0, 12);
    related.slice(0, 4).forEach(function (p) { used[p.handle] = 1; });
    /* карта 2: ЕДИН продукт от съседната категория, различен при всяко зареждане —
       случаен измежду първите 8 най-продавани */
    var sibPool = res[1].filter(function (p) { return !used[p.handle]; }).slice(0, 8);
    var hero = sibPool.length ? sibPool[Math.floor(Math.random() * sibPool.length)] : null;
    if (hero) used[hero.handle] = 1;
    /* карта 4: ЕДИН случаен най-продаван от групата (l1), различен при всяко зареждане */
    var pool = shuffle(res[2].filter(function (p) { return !used[p.handle] && !viewedHandles[p.handle]; })).slice(0, 1);
    if (!pool.length) pool = shuffle(res[2].filter(function (p) { return !used[p.handle]; })).slice(0, 1);

    if (related.length < 4) return; /* няма достатъчно данни → остава скрит */
    var srcInfo = relatedInfo || subInfo || mainInfo;
    var cards = [];
    var groupT = label((l1Info || mainInfo || {}).t || ''), catT = label((subInfo || mainInfo || {}).t || '');
    cards.push(card(tpl(1, 'Препоръки за вас', { group: groupT, cat: catT }), related.slice(0, 4).map(function (p) { return prodTile(p, false); }).join(''), srcInfo ? '/collections/' + srcInfo.h : ''));
    /* заглавието на голямата карта = вендорът на показания продукт; линкът → всичките му продукти */
    if (hero && sibling) {
      var heroTitle = hero.vendor ? tpl(2, 'Оферти от {вендор}', { vendor: hero.vendor, group: groupT, cat: label(sibling.t) }) : 'Хит: ' + label(sibling.t);
      var heroMore = hero.vendor ? '/collections/vendors?q=' + encodeURIComponent(hero.vendor) : '/collections/' + sibling.h;
      cards.push(card(heroTitle, prodTile(hero, true), heroMore));
    }
    if (relCats.length >= 4) cards.push(card(tpl(3, 'Категории за вас', { group: groupT, cat: catT }), relCats.map(colTile).join(''), l1Info ? '/collections/' + l1Info.h : '/collections'));
    var poolTitle = groupT ? tpl(4, 'Разгледайте в {група}', { group: groupT, cat: catT, vendor: pool[0] && pool[0].vendor || '' }) : 'Разгледайте още';
    if (pool.length) cards.push(card(poolTitle, prodTile(pool[0], true), '/collections/' + poolSrc));
    if (cards.length < 2) return;

    var grid = root.querySelector('[data-nika-bp-cards]');
    grid.style.setProperty('--nika-bento-cards', String(cards.length));
    grid.innerHTML = cards.join('');
    /* голямата снимка = от горния ръб на 1-вия ред до долния ръб на 2-рия ред
       снимки в съседната 2x2 карта — бежовите зони застават на една линия */
    var alignHero = function () {
      var ref = grid.querySelector('.nika-bento__card .nika-bento__tiles .nika-bento__tile:not(.nika-bento__tile--hero)');
      var heroes = grid.querySelectorAll('.nika-bento__tile--hero .nika-bento__img');
      if (!ref || !heroes.length) return;
      var imgs = ref.parentElement.querySelectorAll('.nika-bento__tile:not(.nika-bento__tile--hero) .nika-bento__img');
      if (imgs.length < 3) return;
      var h = imgs[2].getBoundingClientRect().bottom - imgs[0].getBoundingClientRect().top;
      if (h > 50) heroes.forEach(function (el) { el.style.setProperty('--nika-hero-h', Math.round(h) + 'px'); });
    };
    alignHero();
    if (window.ResizeObserver) new ResizeObserver(alignHero).observe(grid); else window.addEventListener('resize', alignHero);
    var mob = root.querySelector('[data-nika-bp-mobile]');
    mob.innerHTML = related.map(function (p) { return prodTile(p, false); }).join('');
    root.hidden = false;
    /* резервираната височина (inline script в секцията) вече не е нужна — реалното съдържание е тук */
    root.classList.remove('nika-bento--reserved');
    root.style.minHeight = '';
  }).catch(function (err) { try { console.warn('nika-bento-personal', err); } catch (e) {} /* остава скрит */ root.hidden = true; root.style.minHeight = ''; });
  }).catch(function (err) { try { console.warn('nika-bento-personal map', err); } catch (e) {} });
})();
